export default __webpack_public_path__ + "static/media/login-bg.bf933446.jpg";